import { NavLink } from "react-router-dom";

const navItems = [
  { to: "/", label: "Live", icon: PulseIcon },
  { to: "/schedule", label: "Schedule", icon: CalendarIcon },
  { to: "/leagues", label: "Leagues", icon: TrophyIcon },
];

export function Sidebar() {
  return (
    <aside className="hidden md:flex flex-col items-center w-16 shrink-0 bg-base-950 border-r border-base-600 py-5 gap-6">
      <div className="w-9 h-9 rounded-lg bg-emerald/10 flex items-center justify-center text-emerald font-display font-bold text-sm">
        P
      </div>
      <nav className="flex flex-col items-center gap-2">
        {navItems.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            className={({ isActive }) =>
              `group relative w-11 h-11 rounded-xl flex items-center justify-center transition-colors ${
                isActive ? "bg-emerald/10 text-emerald" : "text-ink-500 hover:text-ink-100 hover:bg-white/5"
              }`
            }
            aria-label={label}
          >
            <Icon className="w-5 h-5" />
            <span className="pointer-events-none absolute left-full ml-3 whitespace-nowrap rounded-md bg-base-700 px-2 py-1 text-xs text-ink-100 opacity-0 group-hover:opacity-100 transition-opacity">
              {label}
            </span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}

function PulseIcon({ className }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M3 12h4l2-7 4 14 3-9 2 4h3" />
    </svg>
  );
}
function CalendarIcon({ className }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path strokeLinecap="round" d="M16 3v4M8 3v4M3 10h18" />
    </svg>
  );
}
function TrophyIcon({ className }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M8 21h8M12 17v4M7 4h10v4a5 5 0 01-10 0V4z" />
      <path strokeLinecap="round" d="M17 5h3a4 4 0 01-4 4M7 5H4a4 4 0 004 4" />
    </svg>
  );
}
